export default "<p>\n  modal-dialog works!\n</p>\n<!-- <app-sign-in> </app-sign-in>\n<app-sign-in> </app-sign-in> -->";